import React from 'react';
import { FuelConsumptionFilters } from '../../../../app/models/FuelConsumption';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
    filter: FuelConsumptionFilters;
    setFilter: (filter: FuelConsumptionFilters) => void;
    onSearch: () => void;
};

const FuelConsumptionFilter = ({ filter, setFilter,onSearch }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="charge_date_from">
                            Fecha carga (desde)
                        </label>
                        <input
                            title="Fecha carga (desde)"
                            type="date"
                            id="charge_date_from"
                            name="charge_date_from"
                            className="form-control form-control-sm"
                            value={filter.charge_date_from}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="charge_date_until">
                            Fecha carga (hasta)
                        </label>
                        <input
                            title="Fecha carga (hasta)"
                            type="date"
                            id="charge_date_until"
                            name="charge_date_until"
                            className="form-control form-control-sm"
                            value={filter.charge_date_until}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className='col-md-auto'>
                    <div style={{marginTop: '22px'}}>
                        <ButtonSearchFilter callbackSearch={onSearch}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FuelConsumptionFilter;
